export default function getFavicon(domain, size = 64) {
  return `https://www.google.com/s2/favicons?sz=${size}&domain_url=${domain}`
}
